// extracted by mini-css-extract-plugin
module.exports = {"wrap":"header_wrap_2Kh1a","icon":"header_icon_3S-er"};